var _defs, _circle, _path, _path2, _path3, _path4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        font-family: ArialRoundedMTBold, 'Arial Rounded MT Bold';\n        font-size: 17.07px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11.79,
    y1: -3.87,
    x2: 37.87,
    y2: 48.67,
    gradientTransform: "translate(0 55.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#544463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9f533b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6403"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.5,
    cy: 27.5,
    r: 27.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.24,24.96c0,.7.19.8.63.96l.66.23v-2.2h-.39c-.49,0-.9.45-.9,1.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.47,31.05h.39c.5,0,.9-.45.9-1.01,0-.7-.19-.8-.63-.96l-.66-.23v2.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.29,19.08l-2.65,2.65c-.19.19-.44.28-.68.28s-.49-.09-.68-.28c-.37-.37-.37-.99,0-1.37l2.65-2.65c-2.27-1.94-5.21-3.13-8.42-3.13-7.13,0-12.92,5.79-12.92,12.92s5.79,12.92,12.92,12.92,12.92-5.79,12.92-12.92c0-3.22-1.19-6.15-3.13-8.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.31,14.21c-.1-.23-.28-.43-.53-.53-.12-.04-.23-.06-.36-.06h-5.17c-.53,0-.97.44-.97.97s.44.97.97.97h2.83l-2.16,2.16c.49.43.94.88,1.37,1.37l2.16-2.16v2.83c0,.53.44.97.97.97s.97-.44.97-.97v-5.17c0-.13-.03-.25-.08-.37Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(22.22 32.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon_dollar.0f49b30f3f0d49144403b0abbe52397f.svg";
export { ForwardRef as ReactComponent };